import React from "react";
import { useNavigate } from "react-router-dom";
import { Crown, X, ArrowRight } from "lucide-react";
import { useBilling } from "../lib/billing";

export default function UpgradeModal() {
  const navigate = useNavigate();
  const { upgradeModal, closeUpgradeModal } = useBilling();
  if (!upgradeModal.open) return null;
  const reason = upgradeModal.reason || {};

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      onClick={closeUpgradeModal}
      data-testid="upgrade-modal-overlay"
    >
      <div
        className="brutal-card max-w-lg w-full p-6 sm:p-8 bg-white relative"
        onClick={(e) => e.stopPropagation()}
        data-testid="upgrade-modal"
      >
        <button
          className="absolute top-3 right-3 p-2 border-2 border-black hover:bg-[#F4F2EC]"
          onClick={closeUpgradeModal}
          data-testid="upgrade-modal-close"
          aria-label="Close"
        >
          <X size={16}/>
        </button>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-[#C2410C] border-2 border-black flex items-center justify-center">
            <Crown size={22} className="text-white"/>
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#4A4A4A]">Limit reached</div>
            <h2 className="font-heading text-2xl font-black uppercase">Time to upgrade</h2>
          </div>
        </div>
        <p className="font-mono text-sm text-[#222] mb-2">
          {reason.message || "You've reached your plan limit."}
        </p>
        {(reason.current !== undefined && reason.maximum !== undefined && reason.maximum > 0) && (
          <div className="font-mono text-xs text-[#4A4A4A] mb-5">
            Current usage: <strong>{reason.current}</strong> / {reason.maximum}
          </div>
        )}
        <div className="brutal-card p-4 mb-6 !bg-[#F4F2EC]">
          <div className="font-heading font-black uppercase mb-2">Pro unlocks</div>
          <ul className="font-mono text-xs space-y-1 text-[#222]">
            <li>· Unlimited products + events</li>
            <li>· Up to 5 team members</li>
            <li>· Per-seller payouts &amp; CSV import</li>
            <li>· COGS, margin, no Vendor Vault badge</li>
          </ul>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => { closeUpgradeModal(); navigate("/billing"); }}
            className="brutal-btn flex-1"
            data-testid="upgrade-modal-cta"
          >
            See plans <ArrowRight size={14} className="ml-2 inline"/>
          </button>
          <button
            onClick={closeUpgradeModal}
            className="brutal-btn brutal-btn-secondary"
            data-testid="upgrade-modal-dismiss"
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
